import { Grid } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useFormik } from "formik";
import * as Yup from "yup";
import Input from "../../../../../components/Input";
import StyledFormModal from "../../../../../components/globalModal/StyledModal";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { useAddTaskTitle } from "../../../../../queries/collaboration/tasks/use-task-title-add";
import { getXtenantId, showToastOnApiCall } from "../../../../../utils/utils";

interface AddTaskTitleModalProps {
  disclosureHost: DisclosureHost;
}

const AddTaskTitleModal = ({ disclosureHost }: AddTaskTitleModalProps) => {
  const { mutateAsync: createTaskTitle } = useAddTaskTitle();
  const showSnackbar = useSnackbar();
  const queryClient = useQueryClient();

  const handleSubmit = async (values: { taskTitle: string }) => {
    showToastOnApiCall({
      showSnackbar,
      apiCall: createTaskTitle({
        taskTitle: values.taskTitle,
        xTENANTID: getXtenantId(),
      }),
      onSave: () => {
        formik.resetForm();
        queryClient.invalidateQueries({
          queryKey: ["task-options-list"],
        });
        disclosureHost.close();
      },
    });
  };

  const formik = useFormik<{ taskTitle: string }>({
    initialValues: {
      taskTitle: "",
    },
    validationSchema: Yup.object().shape({
      taskTitle: Yup.string().trim().required().label("Task Title"),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle={`${disclosureHost?.data ? "Edit" : "Add"} Task Title`}
      dialogAction={
        <StyledButtonV2
          label="Add"
          variant="contained"
          onClick={formik.submitForm}
        />
      }
      sx={{
        "& .MuiDialog-paper": {
          height: "20vh",
          width: "30vw",
        },
      }}
    >
      <Grid container pt={2}>
        <Grid item xs={12}>
          <Input
            label="Task Title"
            textFieldProps={{
              name: "taskTitle",
              value: formik.values.taskTitle,
              onChange: formik.handleChange,
              onBlur: formik.handleBlur,
            }}
            error={formik.errors.taskTitle}
          />
        </Grid>
      </Grid>
    </StyledFormModal>
  );
};

export default AddTaskTitleModal;
